import { useSlots as useSlotsLib } from '@bcraft-frontend-lib/slots'

import { SlotPlace } from '../types'

export const useSlots = useSlotsLib<SlotPlace>
